import React, { useMemo } from "react";
import SupportWidget from "./SupportWidget";
import helpReader from "./helpReader";
import { useBillsOn } from "../Bills/billsOn";

// The reader's help button. The airtime, data and bills topic shows only while Pay bills is on for this reader.
export default function ReaderSupport(props) {
  const billsOn = useBillsOn();
  const help = useMemo(() => {
    if (billsOn) return helpReader;
    const { bills, ...topics } = helpReader.topics;
    return { ...helpReader, topics };
  }, [billsOn]);
  return <SupportWidget side="reader" tokenKey="token" help={help} {...props} />;
}
